import { LoginStatus } from "./action";

const loginList = (state = { islogin: false }, action: any) => {
  switch (action.type) {
    case LoginStatus:
      return { ...state, islogin: !state.islogin };
    default:
      return state;
  }
};

export default loginList;